import { createStorefrontClient } from '@template-project/storefront-bff-client';
import { env } from '@/lib/utils/env';

export interface CreditsConfig {
  currency: string;
  enabled: boolean;
  /** Minimum cart subtotal in cents for credits to unlock. */
  unlock_threshold_cents: number;
  /** Max combined discount (credits + coupon) as % of subtotal (0–100). */
  max_percentage_discount: number;
  updated_at?: string;
}

export interface CreditsBalance {
  user_id: string;
  /** Number of whole credits. 1 credit = $1.00. */
  balance: number;
  currency: string;
}

export interface CreditTransaction {
  id: string;
  /** One of: earned | redeemed | expired | adjusted */
  type: string;
  /** Signed amount in credits; negative for redemptions/expirations */
  amount: number;
  balance_after: number;
  reference_id?: string;
  source: string;
  created_at: string;
}

export interface CreditsTransactions {
  user_id: string;
  transactions: CreditTransaction[];
  limit: number;
  offset: number;
}

function getClient() {
  return createStorefrontClient({
    baseUrl: env.STOREFRONT_BFF_URL,
    tenantId: env.FUNNELS_TENANT_ID,
  });
}

export async function getCreditsConfig(currency: string): Promise<CreditsConfig | null> {
  try {
    const res = await getClient().getCreditsConfig(currency);
    return res.data;
  } catch {
    return null;
  }
}

export async function getUserCreditBalance(userId: string): Promise<CreditsBalance | null> {
  try {
    const res = await getClient().getCreditsBalance(userId);
    return res.data;
  } catch {
    return null;
  }
}

export async function getUserCreditTransactions(userId: string): Promise<CreditsTransactions | null> {
  try {
    const res = await getClient().getCreditsTransactions(userId);
    return res.data;
  } catch {
    return null;
  }
}
